// src/features/dzban/hooks/useVoterFingerprint.js
// Generuje unikalny fingerprint dla anonymous voting (prevent spam)

import { useEffect, useState } from 'react';

// Simple hash function
const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash).toString(36);
};

export const useVoterFingerprint = () => {
  const [fingerprint, setFingerprint] = useState(null);

  useEffect(() => {
    // Check if we already have a fingerprint in localStorage
    const storedFingerprint = localStorage.getItem('dzban_voter_id');
    
    if (storedFingerprint) {
      setFingerprint(storedFingerprint);
      return;
    }

    // Generate new fingerprint from browser characteristics
    const components = [
      navigator.userAgent,
      navigator.language,
      window.screen.width + 'x' + window.screen.height,
      window.screen.colorDepth,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency || 'unknown',
      navigator.platform
    ];

    const fingerprintStr = components.join('|');
    const hash = hashString(fingerprintStr);
    
    // Store in localStorage
    localStorage.setItem('dzban_voter_id', hash);
    setFingerprint(hash);
  }, []);

  // Get today's vote count
  const getVotesCount = () => {
    const today = new Date().toISOString().split('T')[0];
    const storedDate = localStorage.getItem('dzban_votes_date');
    const storedCount = parseInt(localStorage.getItem('dzban_votes_count') || '0');

    // Reset if new day
    if (storedDate !== today) {
      localStorage.setItem('dzban_votes_date', today);
      localStorage.setItem('dzban_votes_count', '0');
      return 0;
    }

    return storedCount;
  };

  // Increment vote count
  const incrementVotes = () => {
    const today = new Date().toISOString().split('T')[0];
    const currentCount = getVotesCount();
    const newCount = currentCount + 1;
    
    localStorage.setItem('dzban_votes_date', today);
    localStorage.setItem('dzban_votes_count', newCount.toString());
    
    return newCount;
  };

  // Check if can vote (under daily limit)
  const canVote = () => {
    return getVotesCount() < 20;
  };

  return {
    voterId: fingerprint,
    votesCount: getVotesCount(),
    canVote: canVote(),
    maxVotes: 20,
    incrementVoteCount: incrementVotes
  };
};
